/**
 * Serien A–Z page — port of SeriesPage.tsx interaction:
 * - scroll-spy: IntersectionObserver on [data-letter-section] with
 *   rootMargin '-15% 0px -75% 0px', threshold 0; the first intersecting
 *   entry per callback wins (matches the source's `break`)
 * - active letter mirrored to BOTH navs (mobile strip + desktop sidebar):
 *   .is-active + aria-current="location" on the matching buttons
 * - letter click: smooth scroll to #series-section-<letter> with the
 *   140px fixed offset from the source
 */
(function () {
  'use strict';

  function initPage(page) {
    if (page.dataset.seriesInit) return;
    page.dataset.seriesInit = '1';

    var sections = Array.prototype.slice.call(page.querySelectorAll('[data-letter-section]'));
    var buttons = Array.prototype.slice.call(page.querySelectorAll('[data-az-letter]'));
    if (sections.length === 0 || buttons.length === 0) return;

    function setActive(letter) {
      buttons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-az-letter') === letter && !btn.disabled;
        btn.classList.toggle('is-active', isActive);
        if (isActive) {
          btn.setAttribute('aria-current', 'location');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) {
            setActive(entries[i].target.getAttribute('data-letter-section') || '');
            break;
          }
        }
      },
      { rootMargin: '-15% 0px -75% 0px', threshold: 0 }
    );
    sections.forEach(function (s) {
      observer.observe(s);
    });

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var el = document.getElementById('series-section-' + btn.getAttribute('data-az-letter'));
        if (!el) return;
        var offset = 140;
        var top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-series-page]').forEach(initPage);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
